
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h513v342H0z"}}),_c('g',{attrs:{"fill":"#D80027"}},[_c('path',{attrs:{"d":"M0 .1h513v90.7H0zM0 251.3h513V342H0z"}})]),_c('circle',{attrs:{"fill":"#FFF","cx":"256.5","cy":"171","r":"65.9"}})])
          )
        }
      }
    